import { Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IFileUploadTypeManage } from "../../_common/interface/fileUploadType/iFileUploadTypeManage";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { fileUploadTypeService } from "../../_services/fileUploadType.service";
import { useDrawerStyles } from "../../_styles/drawer.styles";

export const FileUploadTypeManageDrawer = (params: { isOpen: boolean, itemId: number | null, onSave(): void, onClose(): void }) => {

    const resetData = () => ({
        id: 0,
        name: "",
    });

    const [data, setData] = useState<IFileUploadTypeManage>(resetData);

    useEffect(() => {
        if (params.itemId != null)
            fetchData();
        else
            setData(resetData);
    }, [params.itemId, params.isOpen]);


    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);


    function fetchData() {
        if (!params.itemId) return;

        setIsLoading(true)
        return fileUploadTypeService
            .get(params.itemId)
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return fileUploadTypeService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    params.onSave();
                },
                (e) => toastr.error(e)
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!params.itemId) return;
        setIsLoading(true);
        return fileUploadTypeService
            .disable(params.itemId)
            .then(
                (d) => {
                    toastr.success("Disabled successfully");
                    fetchData();
                    params.onSave();
                },
                (e) => {
                    toastr.error(e);
                }
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data) => ({ ..._data, [event.target.name]: event.target.value }))
    };


    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={params.isOpen}
            ModalProps={{
                keepMounted: true
            }}
        >
            <div
                tabIndex={0}
                role="button">
                <div>

                    <DrawerHeader name={(!!params.itemId) ? "Update File Upload Type" : "Create File Upload Type"} onClose={params.onClose} />

                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="name"
                                    name="name"
                                    label="Name"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:1']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.name}
                                    onChange={handleChange}
                                />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={(data.id === 0 ? 12 : 6)}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    isLoading={isLoading}
                                    type="submit"
                                    variant="save">{"Save"}
                                </PrimaryButton>
                            </Grid>

                            {data.id > 0 &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="danger"
                                        disabled={isLoading}
                                        onClick={disable}
                                        icon="block"
                                    >
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>

                    </ValidatorForm>
                </div>
            </div>
        </Drawer>
    );
};